import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { LabeledRow } from '../../../fulfillment-planner/labeled-row';
import { UserDateTimezoneFormat } from '../../../components/user-date-timezone-format';
import { isValidISOString } from '../../../services/time-helper-service';
import { messages } from '../../../fulfillment-planner/labeled-row/messages';
import style from './style.module.css';

export const DeliveryDate = ({ deliveryDate }) => {
  const normalizedDeliveryDate = isValidISOString(deliveryDate) ? (
    <UserDateTimezoneFormat dateTime={deliveryDate} showTime spaceBetweenTimeAndZone />
  ) : (
    deliveryDate
  );
  return (
    <LabeledRow className={style.row} label={<FormattedMessage {...messages.localDeliveryTime} />} labelClassName={style.label}>
      {deliveryDate ? <span className={style.info}>{normalizedDeliveryDate}</span> : <span className={style.mdash}>&mdash;</span>}
    </LabeledRow>
  );
};

DeliveryDate.propTypes = {
  deliveryDate: PropTypes.string,
};
